/* UbraTech PLP: facet collapse, mobile drawer, sort, compare bar + modal, quick-view. Server does the filtering. */
(function(){
  var d = document;
  function qs(s,r){return (r||d).querySelector(s);}
  function qsa(s,r){return Array.prototype.slice.call((r||d).querySelectorAll(s));}

  /* facet collapse */
  d.addEventListener('click', function(e){
    var h = e.target.closest('[data-facet-toggle]');
    if(h){ h.closest('.facet').classList.toggle('collapsed'); }
  });

  /* mobile filter drawer */
  var fdrawer = qs('#fdrawer');
  var mob = qs('#mobFilter');
  if(mob && fdrawer){ mob.addEventListener('click', function(){ fdrawer.classList.add('on'); }); }
  d.addEventListener('click', function(e){
    if(e.target.closest('[data-close]')){
      var ov = e.target.closest('.ov, .fdrawer');
      if(ov) ov.classList.remove('on');
    }
  });

  /* sort -> update URL param, preserve filters */
  var sort = qs('[data-sort]');
  if(sort){ sort.addEventListener('change', function(){
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  }); }

  /* ---- compare ---- */
  var MAX = 4;
  var picked = []; // {id, el}
  var bar = qs('#cmpbar'), cbN = qs('#cbN'), cbSlots = qs('#cbSlots');
  function cardData(pcard){
    return {
      title: pcard.getAttribute('data-title'), brand: pcard.getAttribute('data-brand'),
      price: pcard.getAttribute('data-price'), url: pcard.getAttribute('data-url'),
      image: pcard.getAttribute('data-image'),
      cpu: pcard.getAttribute('data-cpu'), ram: pcard.getAttribute('data-ram'),
      storage: pcard.getAttribute('data-storage'), screen: pcard.getAttribute('data-screen'),
      resolution: pcard.getAttribute('data-resolution'), panel: pcard.getAttribute('data-panel'),
      availability: pcard.getAttribute('data-availability'),
      variant: pcard.getAttribute('data-variant')
    };
  }
  function renderBar(){
    if(!bar) return;
    cbN.textContent = picked.length;
    cbSlots.innerHTML = '';
    for(var i=0;i<MAX;i++){
      var slot = d.createElement('div');
      if(picked[i]){ slot.className='cmp-slot';
        slot.innerHTML='<button class="rm" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
        (function(p){ slot.querySelector('.rm').addEventListener('click', function(){ toggle(p.el, false); }); })(picked[i]);
      } else { slot.className='cmp-slot ghost'; }
      cbSlots.appendChild(slot);
    }
    bar.classList.toggle('on', picked.length>0);
  }
  function toggle(pcard, on){
    var id = pcard.querySelector('[data-compare]');
    var found = picked.findIndex(function(x){return x.el===pcard;});
    if(on && found<0){ if(picked.length>=MAX){ if(id) id.checked=false; return; } picked.push({el:pcard, data:cardData(pcard)}); }
    else if(!on && found>=0){ picked.splice(found,1); if(id) id.checked=false; }
    renderBar();
  }
  d.addEventListener('change', function(e){
    var cb = e.target.closest('[data-compare]');
    if(cb){ toggle(cb.closest('.pcard'), cb.checked); }
  });
  var cbClear = qs('#cbClear');
  if(cbClear) cbClear.addEventListener('click', function(){ picked.forEach(function(p){ var i=p.el.querySelector('[data-compare]'); if(i) i.checked=false; }); picked=[]; renderBar(); });

  function money(s){ var n=parseFloat((s||'').replace(/[^0-9.]/g,'')); return isNaN(n)?Infinity:n; }
  var cmpModal = qs('#cmpModal'), cmpCard = qs('#cmpCard'), cbGo = qs('#cbGo');
  if(cbGo) cbGo.addEventListener('click', function(){
    if(picked.length<2){ return; }
    var best = Math.min.apply(null, picked.map(function(p){return money(p.data.price);}));
    // baseline rows ALWAYS render (never an empty comparison); spec rows only show if
    // at least one selected product has a value for them (avoids a wall of dashes on
    // e.g. two monitors that lack laptop specs). item 7 · v5-14.
    var baseRows = [['','image'],['Brand','brand'],['Model','title'],['Price','price'],['Availability','availability']];
    var specRows = [['Screen size','screen'],['Resolution','resolution'],['Panel','panel'],['Processor','cpu'],['Memory','ram'],['Storage','storage']];
    var shownSpecs = specRows.filter(function(r){ return picked.some(function(p){ var v=p.data[r[1]]; return v && v.trim(); }); });
    var rows = baseRows.concat(shownSpecs);
    var html = '<button class="ov-close" data-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
    html += '<div class="cmp-modal"><h2>Compare</h2><div class="sub">Side by side — best price highlighted.</div><table class="cmp-table"><tbody>';
    rows.forEach(function(r){
      html += '<tr><td class="rowk">'+r[0]+'</td>';
      picked.forEach(function(p){
        var v = p.data[r[1]];
        if(r[1]==='image'){ html += '<td>'+(v?'<img class="ct-img" src="'+v+'" alt="" loading="lazy">':'<div class="ct-img"></div>')+'</td>'; }
        else if(r[1]==='brand'){ html += '<td class="ct-brand">'+(v||'')+'</td>'; }
        else if(r[1]==='title'){ html += '<td class="ct-title">'+(v||'')+'</td>'; }
        else if(r[1]==='price'){ var isBest = money(v)===best; html += '<td class="ct-price'+(isBest?' best':'')+'">'+(v||'')+'<button class="ct-add" data-add-variant="'+(p.data.variant||'')+'">Add to cart</button></td>'; }
        else { html += '<td>'+(v||'&mdash;')+'</td>'; }
      });
      html += '</tr>';
    });
    html += '</tbody></table></div>';
    cmpCard.innerHTML = html;
    cmpModal.classList.add('on');
  });

  /* ---- quick view ---- */
  var qv = qs('#qv'), qvCard = qs('#qvCard');
  d.addEventListener('click', function(e){
    var b = e.target.closest('[data-quickview]');
    if(!b) return;
    var p = cardData(b.closest('.pcard'));
    var specs = [['Processor',p.cpu],['Memory',p.ram],['Storage',p.storage],['Screen',p.screen]].filter(function(r){return r[1];});
    var html = '<button class="ov-close" data-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
    html += '<div class="qv-grid"><div class="qv-media">'+(p.image?'<img class="qv-img" src="'+p.image+'" alt="'+(p.title||'')+'">':'<div class="ph"></div><span class="phlabel">'+(p.brand||'')+'</span>')+'</div>';
    html += '<div class="qv-info"><div class="pbrand">'+(p.brand||'')+'</div><h2>'+(p.title||'')+'</h2>';
    html += '<div class="qv-price"><span class="price">'+(p.price||'')+'</span><span class="stock"><i></i> In stock</span></div>';
    if(specs.length){ html += '<div class="qv-spectable">'; specs.forEach(function(r){ html+='<div><span class="k">'+r[0]+'</span><span class="v">'+r[1]+'</span></div>'; }); html+='</div>'; }
    html += '<div class="qv-cta"><button class="btn btn-primary" data-add-variant="'+(p.variant||'')+'">Add to cart</button><a class="btn btn-white" href="'+(p.url||'#')+'">View full details</a></div>';
    html += '<div class="qv-links"><a href="https://wa.me/'+(window.UBRA&&window.UBRA.whatsapp||'27690387840')+'"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.4A10 10 0 1 0 12 2z"/></svg> Ask about this</a><span>&#10003; Tracked nationwide delivery</span></div>';
    html += '</div></div>';
    qvCard.innerHTML = html;
    qv.classList.add('on');
  });

  /* close overlays on Escape */
  d.addEventListener('keydown', function(e){ if(e.key==='Escape'){ qsa('.ov.on, .fdrawer.on').forEach(function(o){o.classList.remove('on');}); } });
})();
